import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './video-aspect-ratio.scss';
export var VideoAspectRatioMode;
(function (VideoAspectRatioMode) {
    VideoAspectRatioMode["FIT_TO_HEIGHT"] = "FIT_TO_HEIGHT";
    VideoAspectRatioMode["FIT_TO_WIDTH"] = "FIT_TO_WIDTH";
})(VideoAspectRatioMode || (VideoAspectRatioMode = {}));
const stylesMap = {
    [VideoAspectRatioMode.FIT_TO_HEIGHT]: styles.fitToheight,
    [VideoAspectRatioMode.FIT_TO_WIDTH]: styles.fitToWidth,
};
const image16x9 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJCAIAAAC0SDtlAAAAGklEQVQYlWP8//8/AymAiSTVoxpoooGBgQEAMWADDx3noXgAAAAASUVORK5CYII=';
export class VideoAspectRatio extends React.Component {
    render() {
        const { children, mode } = this.props;
        return (React.createElement("div", { className: styles.container },
            React.createElement("img", { className: classnames(styles.ratioImage, stylesMap[mode]), src: image16x9, alt: "", "aria-hidden": "true" }),
            children));
    }
}
VideoAspectRatio.propTypes = {
    children: PropTypes.any,
    mode: PropTypes.oneOf([
        VideoAspectRatioMode.FIT_TO_HEIGHT,
        VideoAspectRatioMode.FIT_TO_WIDTH,
    ]),
};
VideoAspectRatio.defaultProps = {
    mode: VideoAspectRatioMode.FIT_TO_WIDTH,
};
//# sourceMappingURL=video-aspect-ratio.js.map